"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLIENT_SOURCE_HEADER = exports.ClientSourceEnum = void 0;
var ClientSourceEnum;
(function (ClientSourceEnum) {
    ClientSourceEnum["WEB"] = "web";
    ClientSourceEnum["KIOSK"] = "kiosk";
    ClientSourceEnum["MOBILE"] = "mobile";
})(ClientSourceEnum || (exports.ClientSourceEnum = ClientSourceEnum = {}));
exports.CLIENT_SOURCE_HEADER = 'x-hero-client';
